import store from '@/store/store';

export function AuthGuard (to, from, next) {
    if (store.getters['session/loggedIn']) {
        next();
        return;
    }

    if (to.name === 'Home') {
        next({ name: 'Login' });    
    } else {
        next({ name: 'Login', query: { redirectTo: to.path } });    
    }
}